export class TranslateModel {
    constructor(public key: string, public options?: any, public pluralization?: number) {
    }
}